module.exports = __webpack_public_path__ + "static/media/like.30b465ce.svg";